import './Footer.scss'

export const Footer = () => {

    return (
        <footer className='footer'>

        </footer>
    )
}